import d from "./index19.js";
import { resolveComponent as n, openBlock as o, createBlock as i, createElementBlock as l, createElementVNode as a, toDisplayString as g, createCommentVNode as s, normalizeClass as c, createVNode as k } from "vue";
import "./index20.js";
import C from "../../../../_virtual/index.js";
const v = {
  key: 1,
  class: "footer-mobile"
}, f = {
  key: 0,
  class: "help-link-container"
};
function b(e, t, L, h, F, B) {
  const u = n("FooterSkeletonMobile"), m = n("country-selector"), p = n("FooterMobileLinks"), S = n("TrustLogos"), y = n("Disclaimer");
  return e.notLoaded || !e.areTranslationsLoaded ? (o(), i(u, { key: 0 })) : (o(), l("div", v, [
    e.isSimpleStyle ? s("", !0) : (o(), l("div", f, [
      a("a", {
        class: "help-link",
        href: "/Help/",
        onClick: t[0] || (t[0] = (...r) => e.navigationEventBus.navigateToHref && e.navigationEventBus.navigateToHref(...r))
      }, g(e.t("help")), 1)
    ])),
    a("div", {
      class: c(["country-mobile", [
        e.isCountryDropdownActive ? "active" : "",
        e.isSelectionStyle ? "mobile-selection-page" : ""
      ]]),
      onClick: t[1] || (t[1] = (...r) => e.toggleCountryClass && e.toggleCountryClass(...r))
    }, [
      e.isNormalStyle ? (o(), i(m, {
        key: 0,
        currentCountry: e.countrySelectorSettings.currentCountry,
        countries: e.countrySelectorSettings.countries,
        majorCountries: e.countrySelectorSettings.majorCountries,
        variant: e.countryVariant.NamedFlagWithExpansionOnClick
      }, null, 8, ["currentCountry", "countries", "majorCountries", "variant"])) : s("", !0)
    ], 2),
    e.isSimpleStyle ? s("", !0) : (o(), i(p, {
      key: 1,
      isOnSelectionPage: e.isSelectionStyle
    }, null, 8, ["isOnSelectionPage"])),
    k(S, { isSimpleLogo: e.isSimpleStyle }, null, 8, ["isSimpleLogo"]),
    e.shouldShowDisclaimer ? (o(), i(y, {
      key: 2,
      settings: e.disclaimerSettings,
      class: c(["disclaimer-container", { "simple-disclaimer-container": e.isSimpleStyle }]),
      isQuebec: e.isQuebec
    }, null, 8, ["settings", "class", "isQuebec"])) : s("", !0)
  ]));
}
const T = /* @__PURE__ */ C(d, [["render", b], ["__scopeId", "data-v-a71d6d67"]]);
export {
  T as default
};
//# sourceMappingURL=index10.js.map
